module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-bottom-nav', {
    staticClass: "bottom-tab",
    attrs: {
      "value": _vm.bottomNav
    },
    on: {
      "change": _vm.handleChange
    }
  }, [_c('mu-bottom-nav-item', {
    attrs: {
      "value": "message",
      "title": "Message",
      "icon": "chat_bubble_outline",
      "iconClass": [_vm.isActive[0] && 'color-b'],
      "titleClass": [_vm.isActive[0] && 'color-b']
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "friends",
      "title": "Friends",
      "icon": "people",
      "iconClass": [_vm.isActive[1] && 'color-b'],
      "titleClass": [_vm.isActive[1] && 'color-b']
    }
  }), _vm._v(" "), _c('mu-bottom-nav-item', {
    attrs: {
      "value": "discover",
      "title": "Discover",
      "icon": "explore",
      "iconClass": [_vm.isActive[2] && 'color-b'],
      "titleClass": [_vm.isActive[2] && 'color-b']
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9503256e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bottomtab/bottom-tab.vue
// module id = 525
// module chunks = 1